import jsonata, {JsonataError} from 'jsonata';

import {captureException} from '@zzng/common/utils/matrix';

import {calculatePeriod} from '@/shared/utils/calculatePeriod';

export interface JsonataCustomFunctions {
  /**
   * 기간을 계산하여 표기 변환
   * 29일 이하 → N일
   * 1개월 이상 ~ 1년 미만 → N개월 (N일은 버림)
   * 1년 이상 → N년 N개월 (0개월인 경우 N년만 표기)
   */
  calculatePeriod: (start: string, end: string | null) => string;
}

export interface WithJsonataInput<T = object> {
  value?: string;
  jsonataInput?: T | null;
}

const CUSTOM_FUNCTIONS: JsonataCustomFunctions = {
  calculatePeriod
};

export const evaluateByJsonata = async <T extends WithJsonataInput | undefined>(props: T): Promise<T> => {
  if (!props?.jsonataInput || !props.value) return props;

  const {value} = props;
  const expression = jsonata(value);

  // 커스텀 함수가 포함된 query인 경우 커스텀 함수 등록
  Object.entries(CUSTOM_FUNCTIONS).forEach(([key, func]) => {
    if (value.includes(`$${key}`)) {
      expression.registerFunction(key, func);
    }
  });

  let evaluatedValue = '';

  try {
    evaluatedValue = await expression.evaluate(props.jsonataInput);
  } catch (err) {
    const error = err as JsonataError;
    captureException(`Jsonata 변환 실패 [${error.code}]: ${error.message}\n${JSON.stringify(props)}`);
  }

  return {
    ...props,
    value: evaluatedValue
  };
};
